import React, { Component } from 'react';
import { BrowserRouter, Switch, Redirect, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { isUserAuthenticated,getLoggedInUser } from '../helpers/authUtils';
import * as layoutConstants from '../constants/layout';
import Pages from './../routes/pages';
import * as FeatherIcon from 'react-feather';
const Login = React.lazy(() => import('../pages/auth/Login'));
const Logout = React.lazy(() => import('../pages/auth/Logout'));
const AuthSuccess = React.lazy(() => import('../pages/auth/AuthSuccess'));
const SponsorApprovalAction= React.lazy(() => import('../pages/apps/Sponsor/ApprovalAction'));
const CorporateApprovalAction= React.lazy(() => import('../pages/apps/Corporate/CorporateApprovalAction'));
const ReportApprovalAction= React.lazy(() => import('../pages/apps/Report/ApprovalAction'));
const Home = React.lazy(() => import('../pages/apps/Home/index'));
const IncomingCallView= React.lazy(() => import('../pages/apps/Intake/IncomingCallView'));
const CounsellingSummaryForm= React.lazy(() => import('../pages/apps/Intake/CounsellingSummary'));
const AddTalksForm= React.lazy(() => import('../pages/apps/Intake/AddTalks'));
const CalendarView= React.lazy(() => import('../pages/apps/Intake/CalendarV1'));
// Lazy loading and code splitting -
// Derieved idea from https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const loading = () => <div></div>;

const flattenRoutes = routes => {
    let flatRoutes = [];

    routes = routes || [];
    routes.forEach(item => {
        flatRoutes.push(item);

        if (typeof item.children !== 'undefined') {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

const PrivateRoute = ({ component: Component, roles, ...rest }) =>{
    return (
    <Route
        {...rest}
        render={props => {
            if (!isUserAuthenticated()) {
                return <Redirect to={{ pathname: '/account/login', state: { from: props.location } }} />;
            }  

            const loggedInUser = getLoggedInUser();

            let matched=loggedInUser?.role?.split(',').filter(x => roles?.split(',').includes(x))
            if(matched.length>0 || !roles ||roles.length==0){ /* Do Nothing */ }else{
                return <Redirect to={{ pathname: '/' }} />;
            }

            return <Component {...props} />;
        }}
    />
)};

const rootRoute = {
    path: '/',
    exact: true,
    component: () => <Redirect to="/home" />,
    route: PrivateRoute,
};
const authRoutes = {
    path: '/account',
    name: 'Auth',
    children: [
        {
            path: '/account/login',
            name: 'Login',
            component: Login,
            route: Route,
        },
        {
            path: '/account/logout',
            name: 'Logout',
            component: Logout,
            route: Route,
        },{
            path: '/auth-success',
            name: 'AuthSuccess',
            component: AuthSuccess,
            route: Route,
        },
        {
            path: '/apps/sponsor/approval/:id/:action',
            name: 'Approval',
            component: SponsorApprovalAction,
            route: Route,
        },
        {
            path: '/approvalaction/:id/:action',
            name: 'Approval',
            component: CorporateApprovalAction,
            route: Route,
        },        
        {
            path: '/apps/emailreport/approval/:id/:action',
            name: 'Report Approval',
            component: ReportApprovalAction,
            route: Route,
        }
        ,
        {
            path: '/home',
            name: 'Home',
            component: Home,
            route: PrivateRoute,
        },
        {
            path: '/apps/intake/incomingcall',
            name: 'Intake Incoming Call',
            component: IncomingCallView,
            route: Route,
        } ,
        {
            path: '/apps/intake/counselling-summary',
            name: 'Counselling Summary',
            component: CounsellingSummaryForm,
            route: Route,
        },
        {
            path: '/apps/intake/add-talks',
            name: 'Add Talks',
            component: AddTalksForm,
            route: Route,
        },
        {
            path: '/apps/intake/calendar',
            name: 'Calendar  V1',
            component: CalendarView,
            route: Route,
        }                 
    ],
};



// All layouts/containers
const AuthLayout = Loadable({
    loader: () => import('../layouts/Auth'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const VerticalLayout = Loadable({
    loader: () => import('../layouts/Vertical'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

const HorizontalLayout = Loadable({
    loader: () => import('../layouts/Horizontal'),
    render(loaded, props) {
        let Component = loaded.default;
        return <Component {...props} />;
    },
    loading,
});

class Routes extends Component {

    // returns the layout
    getLayout = () => {
        if (!isUserAuthenticated()) return AuthLayout;

        let layoutCls = '';
        switch (this.props.layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    }

    getAllRoutes = () => {
        let allRoutes1=this.props.menu?this.props.menu:[]
        let allRoutes = [rootRoute,authRoutes,...allRoutes1] 
        let flat=flattenRoutes(allRoutes)

        flat.forEach((n)=>{
            if(n.component){
                n.component=Pages({component:n.component})
            }else{
                delete n.component
            }          
            n.route=(typeof n.route=="string" && n.route=="PrivateRoute")?PrivateRoute:(typeof n.route=="string" && n.route=="Route")?Route:n.route?n.route:Route
            if(n.icon && n.icon!=""){
                n.icon=FeatherIcon[n.icon]?FeatherIcon[n.icon]:null //n.icon=="Briefcase"?FeatherIcon.Briefcase:null
            }
            return n
        })       
       return allRoutes?flat:[]
    }

    render() {
        const Layout = this.getLayout();
        const routess = this.getAllRoutes();       
        return routess?<BrowserRouter>
            <Layout {...this.props}>
                <Switch>
                    {routess?.map((route, index) => {
                        return (
                            !route.children ?
                                <route.route
                                    key={index}
                                    path={route.path}
                                    roles={route.roles}
                                    exact={route.exact}
                                    component={route.component}></route.route>
                                : null
                        );
                    })}
                </Switch>
            </Layout>
        </BrowserRouter>:<></>
    }
}

const mapStateToProps = state => {
    return {
        menu:state.AppMenu.menuItems,
        layout: state.Layout,
        user: state.Auth.user,
    };
};

export default connect(
    mapStateToProps,
    null
)(Routes);
